import Vue from 'vue'
import Router from 'vue-router'
import Start from 'common/components/start'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/start',
      component: Start
    },
    {
      path: '/answer/start/:userID/:answerID/:role/:ocId',
      component: () => import('answer/pages/AnswerCommon')
    },
    {
      path: '/answer/start/:userID/:answerID/:role',
      component: () => import('answer/pages/AnswerCommon')
    },
    {
      path: '/answer/publish/:userID/:answerID/:ocId',
      props: true,
      name: 'publish',
      component: () => import('answer/pages/Publish')
    },
    {
      path: '/answer/publish/:userID/:answerID',
      props: true,
      name: 'publish',
      component: () => import('answer/pages/Publish')
    },
    {
      path: '/answer/check/:userID/:answerID/:type/:ocId',
      component: () => import('answer/pages/Check')
    },
    {
      path: '/',
      redirect: '/start'
    }, {
      path: '/answer/detail/:userID/:answerID/:ocId',
      component: () => import('answer/pages/Detail')
    }, {
      path: '/answer/choseStu',
      component: () => import('answer/pages/choseStu')
    },
    {
      path: '/choseClass/:userID/:ocId',
      component: () => import('answer/pages/choseClass'),
      meta: {
        title: '选择班级'
      }
    },
    {
      path: '/answer/stuDetail/:userID/:answerID',
      component: () => import('answer/pages/stuDetail'),
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js